import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type {
  KBTagDefinition,
  KBTagCreatePayload,
  KBTagUpdatePayload,
  KBTagDeleteResult,
} from '@/common-types';
import type { KbTagsListResponse } from '@/types/application/models/service/kb-tag-model-responses';

export async function listTags(): Promise<KBTagDefinition[]> {
  const response = await fetchApi<KbTagsListResponse>(API_ENDPOINTS.KB_TAGS);
  return response.data.tags ?? [];
}

export async function createTagDefinition(payload: KBTagCreatePayload): Promise<KBTagDefinition> {
  const response = await fetchApi<KBTagDefinition>(API_ENDPOINTS.KB_TAGS, {
    method: 'POST',
    body: {
      key: payload.key.trim(),
      ...(payload.description?.trim() ? { description: payload.description.trim() } : {}),
    },
  });
  return response.data;
}

export async function updateTagDefinition(
  tagId: string,
  payload: KBTagUpdatePayload,
): Promise<KBTagDefinition> {
  const response = await fetchApi<KBTagDefinition>(API_ENDPOINTS.KB_TAG_BY_ID(tagId), {
    method: 'PATCH',
    body: { description: payload.description.trim() },
  });
  return response.data;
}

export async function deleteTagDefinition(
  tagId: string,
  options?: { force?: boolean },
): Promise<KBTagDeleteResult> {
  const response = await fetchApi<KBTagDeleteResult>(API_ENDPOINTS.KB_TAG_BY_ID(tagId), {
    method: 'DELETE',
    ...(options?.force ? { body: { force: true } } : {}),
  });
  return response.data;
}

export default {
  listTags,
  createTagDefinition,
  updateTagDefinition,
  deleteTagDefinition,
};
